import { isTest } from '../utils/isProd';

const BASE_URL = isTest ? '//test.www.sohu.com' : `//www.sohu.com`;

export const linkHelper = (uri: string): string => {
    if (!uri) { return ''; }
    if (!~uri.indexOf('//')) {
        if (uri.slice(0, 1) === '/') {
            return [BASE_URL, uri].join('');
        }
        return [BASE_URL, uri].join('/');
    }
    return uri;
};



// WEBPACK FOOTER //
// ./src/utils/linkHelper.ts